import Vue from 'vue'
import Vuex from 'vuex'
import states from './modules/states'
import modal from './modules/modal'
import alert from './modules/alert'
import auth from './modules/auth'
import user from './modules/user'

import kundekontrakt from './modules/kundekontrakt'
import kundekontraktobjekt from './modules/kundekontraktobjekt'
import kundeobjektbuyer from './modules/kundeobjektbuyer'
import kundeobjektseller from './modules/kundeobjektseller'
import kundeobjektdeliver from './modules/kundeobjektdeliver'
import kundeobjektsignature from './modules/kundeobjektsignature'
import kundeobjektbuyerinvoice from './modules/kundeobjektbuyerinvoice'
import kundenotat from './modules/kundenotat'
import kontraktnotat from './modules/kontraktnotat'
import objektnotat from './modules/objektnotat'
import kundefullmakt from './modules/kundefullmakt'
import objektimageloader from './modules/objektimageloader'
import kundehistory from './modules/kundehistory'
import kontrakthistory from './modules/kontrakthistory'
import objekthistory from './modules/objekthistory'
import objektbesikt from './modules/objektbesikt'
import objektkonsult from './modules/objektkonsult'
import objektbilag from './modules/objektbilag'
import kundebilag from './modules/kundebilag'
import objectsearch from './modules/objectsearch'
import customersearch from './modules/customersearch'
import forhandsbud from './modules/forhandsbud'
import telefonbud from './modules/telefonbud'
import spader from './modules/spader'
import tilslagsskjermbilde from './modules/tilslagsskjermbilde'
import presence from './modules/presence'
import winereport from './modules/winereport'
import nettauksjon from './modules/nettauksjon'
import vinpakkeliste from './modules/vinpakkeliste'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    states,
    modal,
    alert,
    auth,
    user,
    kundeobjektbuyer,
    kundeobjektseller,
    kundekontraktobjekt,
    kundeobjektbuyerinvoice,
    kundeobjektdeliver,
    kundeobjektsignature,
    kundekontrakt,
    kundenotat,
    kontraktnotat,
    objektnotat,
    kundefullmakt,
    objektimageloader,
    kundehistory,
    kontrakthistory,
    objekthistory,
    objektbesikt,
    objektkonsult,
    objektbilag,
    kundebilag,
    objectsearch,
    customersearch,
    tilslagsskjermbilde,
    forhandsbud,
    telefonbud,
    spader,
    presence,
    winereport,
    nettauksjon,
    vinpakkeliste
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js